module.exports = __webpack_public_path__ + "static/media/coimbra-4.da993565.jpg";